import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import illustration from 'modules/surveys/components/Analytics/_BlankSlate/illustration.svg'
import IllustratedBlankSlate from 'modules/surveys/components/IllustratedBlankSlate'

const FilteredBlankSlate = () => (
  <IllustratedBlankSlate
    illustration={illustration}
    description={i18n.t('surveys.form.tabs.no_results.filtered_description')}
  />
)

export default FilteredBlankSlate
